<div class='body'>
  <nav class='navbar navbar-expand-md'>
    <div class='container'>
      <a class='navbar-brand' href='/'>
        <img class='img-fluid' src='../../assets/images/allegria.png' alt=''>
      </a>
      <a href='tel:+201001040090' dir='ltr' class='btn tel d-lg-none d-block'>01001040090</a>
      <button class='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarSupportedContent'
        aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
        <i class='fas fa-bars'></i>
      </button>
      <div class='collapse navbar-collapse' id='navbarSupportedContent'>
        <ul class='navbar-nav ml-auto mb-2 mb-lg-0'>
          <li class='nav-item'>
            <a class='nav-link active' aria-current='page' routerLink='/'>Home</a>
          </li>
          <li class='nav-item'>
            <a class='nav-link' routerLink='/allegria-en'>allegria</a>
          </li>
          <li class='nav-item'>
            <a class='nav-link' routerLink='/estate-en'>ESTATE</a>
          </li>
          <li class='nav-item'>
            <a class='nav-link' routerLink='/vye-en'>VYE</a>
          </li>
          <li class='nav-item'>
            <a class='nav-link' routerLink='/eastvale-en'>Eastvale</a>
          </li>
          <li class='nav-item'>
            <a class='nav-link' (click)='scroll(contactUs)'>Contact Us</a>
          </li>
          <li class='nav-item'>
            <a class='nav-link' href='tel:+201001040090'>
              <svg xmlns='http://www.w3.org/2000/svg' width='20.534' height='20.581' viewBox='0 0 20.534 20.581'>
                <path id='Path_41' data-name='Path 41'
                  d='M33.868,37.277a12.819,12.819,0,0,1,3.222-4.043.677.677,0,0,1,.9-.075c.375.374,3.446,3.893,3.446,3.893a.743.743,0,0,1-.075.973c-.524.524-2.173,2.1-2.173,2.1a.87.87,0,0,0,.075.973,28.192,28.192,0,0,0,6.368,6.289.852.852,0,0,0,.9.15s1.648-1.722,2.1-2.171a.7.7,0,0,1,.974-.15s3.521,3.07,3.9,3.519a.676.676,0,0,1-.075.9c-1.049,1.048-2.622,2.7-4.046,3.22C44.807,54.573,32.07,41.845,33.868,37.277Zm18.58,11.83c-.45-.449-1.049-.973-1.5-1.348-.6-.524-1.2-1.048-1.723-1.5-.674.6-1.274,1.273-1.948,1.947a1.805,1.805,0,0,1-2.248.075A30.556,30.556,0,0,1,38.439,41.7a1.935,1.935,0,0,1-.15-2.1l.15-.225c.674-.6,1.349-1.273,2.023-1.872-.9-1.048-1.948-2.321-2.922-3.294l-.45.449a11.468,11.468,0,0,0-2.323,2.995c-.375,1.048.524,2.845.974,3.744a29.162,29.162,0,0,0,4.2,5.316A25.719,25.719,0,0,0,45.256,50.9c.9.524,2.772,1.348,3.821.973a12.42,12.42,0,0,0,3-2.321C52.224,49.407,52.3,49.257,52.449,49.108Z'
                  transform='translate(-33.396 -32.728)' fill='#31aade' stroke='#31aade' stroke-width='0.5'
                  fill-rule='evenodd' />
              </svg>
              <span>+201001040090</span>
            </a>
          </li>
          <li class='nav-item'>
            <a class='nav-link btn btn-language' routerLink='/allegria-ar'>عربي</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <main>
    <section class='header'>
      <div class='card-img-overlay'>
        <div class='row'>
          <div class='col-lg-8 col-md-10 mx-auto'>
            <div class='about'>
              <h1>The Allegria</h1>
              <p>Greg Norman Designed The Allegria Golf Course To Be A Natural Extension Of The Allegria Community, A
                Part Of It's Philosophy Of A Happy,
                Integrated Neighborhood. The Course Blends In Harmoniously With The Overall Shapes, Colours And
                Intricate Nuances Of The Allegria. Lakes,
                Streams, Rock Features, Vegetation And Undulating Topography Are The Natural Elements Implemented In The
                Design Of The Allegria, One Of Cairo's
                Most Exclusive Residential Communites. The Ingenuity Of The Greg Norman Design Is Exemplified By The
                Playing Experience Of Varying Golfers,
                With
                The Course Both Playable For Beginners And Accomplished Golfers Alike. The Allegria Has All The
                Outstanding Characteristics Making It A
                Magnificent Golf Course Truly Unique To Egypt And The Region.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class='units'>
      <h2>available units</h2>
      <div class='container'>
        <div class='row'>
          @for (unit of units; track unit) {
          <div class='col-xl-3 col-lg-4 col-sm-6 mb-3'>
            <div class='unit'>
              <h3 [title]='unit.name'>{{unit.name}}</h3>
              <div class='images-con'>
                <owl-carousel-o [options]='customOptions'>
                  @for (image of unit.images; track image) {
                  <ng-template carouselSlide>
                    <div class='img-con' [style.backgroundImage]="'url('+ image +')'"></div>
                  </ng-template>
                  }
                </owl-carousel-o>
              </div>
              <div class='data'>
                <p class='location'>{{unit.location}}</p>
                <p>land area:
                  <span>{{unit.landArea}} m
                    <sup>2</sup>
                  </span>
                </p>
                <p>building area:
                  <span>{{unit.buildingArea}} m
                    <sup>2</sup>
                  </span>
                </p>
                <p>floors:
                  <span>{{unit.floors}} floors</span>
                </p>
                @if (unit.guard) {
                <p>guard room:
                  <span>{{unit.guard}} m
                    <sup>2</sup>
                  </span>
                </p>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </section>
    <section class='contact-us' #contactUs>
      <h2>Contact Us</h2>
      <div class='container'>
        <div class='row'>
          <div class='col-lg-4 col-md-8 mx-auto'>
            <form [formGroup]='updateForm' (ngSubmit)='onSubmit()' class='contact-box'>
              <div class='form-group'>
                <input title='name' type='text' class='form-control' placeholder='your name' formControlName='name'>
                <app-field-error [displayError]="isFieldValid('name')"
                  errorMsg='Please Enter your name'></app-field-error>
              </div>
              <div class='form-group'>
                <input title='email' type='email' inputmode='email' class='form-control' placeholder='your email'
                  formControlName='email'>
                <app-field-error [displayError]="isFieldValid('email')"
                  errorMsg='Please Enter a valid email address'></app-field-error>
              </div>
              <div class='form-group'>
                <input type='text' title='phone' inputmode='numeric' class='form-control' placeholder='your phone'
                  formControlName='phone'>
                <app-field-error [displayError]="isFieldValid('phone')"
                  errorMsg='Please Enter a valid phone number'></app-field-error>
              </div>
              <div class='form-group'>
                <textarea title='your message' class='form-control' placeholder='your message'
                  formControlName='notes'></textarea>
                <app-field-error [displayError]="isFieldValid('notes')"
                  errorMsg='Please Enter your message & must be more than 20 character'></app-field-error>
              </div>
              <button class='btn' [disabled]='submitted'>submit</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  </main>
  <footer>made with
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='22' viewBox='0 0 24 22'>
      <g id='Path_2' data-name='Path 2' fill='none'>
        <path
          d='M12,22C5.548,17.607,2.164,13.611.776,10.267-2.942,1.3,7.677-2.983,12,2.308c4.323-5.291,14.942-1,11.224,7.958C21.836,13.611,18.452,17.607,12,22Z'
          stroke='path' fill='#EF4023' />
      </g>
    </svg>
    by
    <a href='http://developnetwork.net/'>develop network</a>
  </footer>
</div>